import PropTypes from 'prop-types';
import React, { cloneElement, useState } from 'react';
import { createChainedFunction } from '@atc/create-chained-function';
function ModalTrigger(_ref) {
  let {
    children,
    modal,
    onClick,
    showModal = false,
    ...rest
  } = _ref;
  const [isModalVisible, setIsModalVisible] = useState(showModal);
  const hide = () => {
    setIsModalVisible(false);
  };
  const toggle = () => {
    setIsModalVisible(!isModalVisible);
  };
  const stopPropagation = event => {
    event.stopPropagation();
  };
  const getModal = () => {
    const modalProps = {
      key: 'modal',
      show: isModalVisible,
      onHide: createChainedFunction(modal.props.onHide, hide)
    };
    return /*#__PURE__*/cloneElement(modal, modalProps);
  };
  const getTrigger = () => {
    const trigger = React.Children.only(children);
    const props = {
      key: 'modal-trigger'
    };
    props.onClick = createChainedFunction(onClick, toggle);
    return /*#__PURE__*/cloneElement(trigger, props);
  };
  return /*#__PURE__*/React.createElement("span", Object.assign({
    onClick: stopPropagation
  }, rest, {
    role: "button",
    tabIndex: "0"
  }), getTrigger(), getModal());
}
export default ModalTrigger;